<template>
    <div class="base-input textarea" :class="{'row': !isFloat}">
        <div v-if="!isFloat" class="col-sm-4 field-label">{{ label }}</div>
        <div class="form-group" :class="{'col-sm-8': !isFloat, 'form-group--centered': isCentered }">
            <label v-if="isFloat && label">{{ label }}<span class="textarea__mandatory" v-if="mandatory">*</span></label>
            <textarea class="form-control textarea-autosize" :id="id" :name="name" :value="localValue" :placeholder="placeHolder"
                  :class="[{ 'form-control--active': isLabelFloatActive, 'is-invalid': errors && errors.has(name)}, getSizeClass]"
                  v-validate="getValidators" :data-vv-as="label"
                      @input="handleInput($event.target.value)">
            </textarea>
            <i class="form-group__bar"></i>
            <div class="invalid-feedback">
                {{ errors && errors.first(name) }}
            </div>
        </div>
    </div>
</template>

<script>
    import formElementMixin from '@/components/mixins/FormElementMixin'
    import autosize from 'autosize'

    export default {
        mixins: [formElementMixin],

        props: {
            type: {default: 'text'}
        },

        computed: {
            element() {
                return $('.textarea-autosize', this.$el)
            }
        },

        data() {
          return {
            localValue: this.value
          };
        },

        watch: {
          value(newVal) {
            if (newVal !== this.localValue) {
              this.localValue = newVal;
            }
          }
        },

        mounted() {
            autosize(this.element);
        },

        destroyed() {
            autosize.destroy(this.element)
        },

        methods: {
          handleInput(newValue) {
            this.localValue = newValue;
            this.$emit('input', newValue);
          }
        }
    }
</script>
<style lang="scss">@import "@/assets/scss/components/form_elements/_textarea.scss";</style>